import { MAX_IMAGE_FILE_SIZE_MB } from '@/common/constants/file.constants'
import { z } from 'zod'

const hexColorRegex = /^#([A-Fa-f0-9]{6})$/
const allowedMimeTypes = ['image/png', 'image/gif', 'image/jpeg']

const MAX_ICON_SIZE_IN_BYTES = MAX_IMAGE_FILE_SIZE_MB * 1024 * 1024

const getFileValidationIssues = (file?: File | string | null) => {
  if (!file || typeof file === 'string') return []

  const issues: { message: string }[] = []

  if (!allowedMimeTypes.includes(file.type)) {
    issues.push({ message: 'Formatos aceitos: PNG, JPG, JPEG ou GIF' })
  }

  if (file.size > MAX_ICON_SIZE_IN_BYTES) {
    issues.push({ message: `Tamanho máximo permitido: ${MAX_IMAGE_FILE_SIZE_MB}MB` })
  }

  return issues
}

const baseBadgeSchema = z.object({
  display_name: z
    .string()
    .trim()
    .min(1, { message: 'Campo obrigatório' })
    .max(12, { message: 'Máximo de 12 caracteres' }),
  background_color: z
    .string()
    .trim()
    .regex(hexColorRegex, { message: 'Informe uma cor hexadecimal válida (ex: #A1B2C3)' }),
  text_color: z
    .string()
    .trim()
    .regex(hexColorRegex, { message: 'Informe uma cor hexadecimal válida (ex: #FFFFFF)' }),
  icon: z.custom<File | string | null>().optional(),
})

export const createTmaisBadgeSchema = baseBadgeSchema.superRefine((data, ctx) => {
  if (!(data.icon instanceof File)) {
    ctx.addIssue({
      path: ['icon'],
      code: z.ZodIssueCode.custom,
      message: 'Selecione um ícone',
    })
    return
  }

  const issues = getFileValidationIssues(data.icon)

  issues.forEach((issue) =>
    ctx.addIssue({
      path: ['icon'],
      code: z.ZodIssueCode.custom,
      message: issue.message,
    }),
  )
})

export const updateTmaisBadgeSchema = baseBadgeSchema.superRefine((data, ctx) => {
  if (data.icon instanceof File) {
    const issues = getFileValidationIssues(data.icon)

    issues.forEach((issue) =>
      ctx.addIssue({
        path: ['icon'],
        code: z.ZodIssueCode.custom,
        message: issue.message,
      }),
    )
  }
})

export type TmaisBadgeFormSchema = z.infer<typeof baseBadgeSchema>
